import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PublicTimetableService from '../../services/PublicTimetableService';
import { currentSchoolWeek } from './publicTimetableDates';
import PublicTimetableCalendar from './PublicTimetableCalendar';
import './publicTimetable.scss';

export default function PublicTimetablePage() {
  const { t } = useTranslation();
  const [weekStart, setWeekStart] = useState(currentSchoolWeek);
  const [attempt, setAttempt] = useState(0);
  const [result, setResult] = useState({ status: 'loading' });
  useEffect(() => {
    const refreshWeek = () => setWeekStart(currentSchoolWeek());
    const timer = setInterval(refreshWeek, 60000);
    window.addEventListener('focus', refreshWeek);
    return () => { clearInterval(timer); window.removeEventListener('focus', refreshWeek); };
  }, []);
  useEffect(() => {
    let active = true;
    setResult({ status: 'loading' });
    PublicTimetableService.getWeek(weekStart).then(data => {
      if (active) setResult({ status: 'ready', data, weekStart });
    }).catch(() => {
      if (active) setResult({ status: 'error' });
    });
    return () => { active = false; };
  }, [weekStart, attempt]);
  const ready = result.status === 'ready' && result.weekStart === weekStart;
  return (
    <section className="fixed-header-page public-timetable container-fluid pb-5" aria-labelledby="public-timetable-title">
      <h1 id="public-timetable-title">{t('public:timetable.title')}</h1>
      <p>{t('public:timetable.intro')}</p>
      <h2 className="h5">{t('public:timetable.current')}</h2>
      <p>{t('public:timetable.timeZone')}</p>
      <div aria-live="polite" aria-busy={result.status === 'loading'}>
        {result.status === 'loading' && <p role="status">{t('public:timetable.loading')}</p>}
        {result.status === 'error' && (
        <div className="alert alert-danger" role="alert">
          <p>{t('public:timetable.error')}</p>
          <button type="button" className="btn btn-outline-dark" onClick={() => setAttempt(value => value + 1)}>{t('public:timetable.retry')}</button>
        </div>
        )}
        {ready && result.data.lessons.length === 0 && <p role="status">{t('public:timetable.empty')}</p>}
        {ready && result.data.lessons.length > 0 && (
        <PublicTimetableCalendar key={weekStart} lessons={result.data.lessons} weekStart={weekStart} />
        )}
      </div>
    </section>
  );
}
